/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Grid, Card, CardContent } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import RegistrateFormComponent from '../../components/Forms/RegistrateFormComponent';
import { useThemeData } from '../../context/ThemeDataContext';
import GeneralButton from '../../components/Buttons';

function Register({ t }) {
    const {
        font_family,
        primary_color_2,
    } = useThemeData().themeData.site.theme;
    const [messages, setMessages] = useState({ message: false });

    return (
        <Grid
            item
            xs={12}
            md={6}
            className="loginscreen"
            style={{ fontFamily: font_family, color: primary_color_2 }}
        >
            <Card>
                <CardContent>
                    {!messages.message ? (
                        <Grid container>
                            <Grid item xs={12} lg={6} className="contact-text">
                                <RegistrateFormComponent setMessages={setMessages} />
                            </Grid>
                            <Grid item xs={12} lg={6}></Grid>
                        </Grid>
                    ) : (
                        <>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Alert severity="success" className="mb-2">
                                        {t('register:Succesmessage')}
                                    </Alert>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={12}>
                                    <GeneralButton
                                        href="/login"
                                        className="submit_login col-md-2 col-lg-2"
                                        style={{ width: '-webkit-fill-available' }}
                                    >
                                        {t('register:Loginpage')}
                                    </GeneralButton>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </CardContent>
            </Card>
        </Grid>
    );
}

export default React.memo(withTranslation(['message', 'register'])(Register));
